"use client";

import { Button, Heading, Image, Text } from "@pamperedchef/design-system";

import type { CallToAction } from "@/composites/foundation";
import * as styles from "./CollectionHero.module.scss";

export interface CollectionHeroProps {
	headline: string;
	description?: string;
	image?: { src: string; alt: string };
	action?: CallToAction;
	/** Navigation stays with the caller; composites do not touch `window`. */
	onActionPress?(action: CallToAction): void;
}

export function CollectionHero({
	headline,
	description,
	image,
	action,
	onActionPress
}: CollectionHeroProps): JSX.Element {
	return (
		<section
			className={styles["hero"]}
			data-component="CollectionHero"
			data-has-image={image ? "true" : "false"}
		>
			<div className={styles["hero__copy"]}>
				<Heading tag="h1" className={styles["hero__headline"]}>
					{headline}
				</Heading>
				{description ? (
					<Text tag="p" className={styles["hero__description"]}>
						{description}
					</Text>
				) : null}
				{action ? (
					<Button
						kind="primary"
						size="lg"
						className={styles["hero__action"]}
						aria-label={action.assistiveText}
						onPress={() => onActionPress?.(action)}
					>
						{action.label}
					</Button>
				) : null}
			</div>
			{image ? (
				<div className={styles["hero__media"]}>
					<Image
						src={image.src}
						alt={image.alt}
						className={styles["hero__image"]}
					/>
				</div>
			) : null}
		</section>
	);
}
